import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import { mail } from "~/store/auth/actions";

// Components
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";

const PwChangeForm = ({ setCurrentStep }) => {
	const pwChangeForm = useForm();
	const [searchParams, setSearchParams] = useSearchParams();
	const [{ auth }, dispatch] = useGlobalStore();
	const token = searchParams.get("token");

	const passwordChangeRequest = useRequest("post", "/vc/user/pw/change");

	useEffect(() => {
		dispatch(mail({ accessToken: token }));
	}, [dispatch, token]);

	const submit = (data) => {
		if (auth.accessToken === "") return;
		passwordChangeRequest.call({ pw: data.pw });
	};

	useEffect(() => {
		switch (passwordChangeRequest.state) {
			case API_STATE.done:
				setCurrentStep("complete");
				break;
			case API_STATE.error:
			default:
				if (!passwordChangeRequest.error) return;
				console.log("error", passwordChangeRequest.error);
				break;
		}
	}, [
		passwordChangeRequest.state,
		passwordChangeRequest.response,
		passwordChangeRequest.error,
		setCurrentStep,
	]);

	const { t } = useTranslation();

	return (
		<>
			<div className="phrase-wrap">
				<h3>{t("pages.auth.FindPwPage.Change.PwChangeForm.enterNewPassword")}</h3>
				<p>{t("pages.auth.FindPwPage.Change.PwChangeForm.protectInfo")}</p>
			</div>
			<Form useForm={pwChangeForm} className="pw-change-form">
				<Input
					type={"password"}
					name={"pw"}
					placeholder={t("pages.auth.FindPwPage.Change.PwChangeForm.newPassword")}
					autoComplete="new-password"
					validation={{
						required: t("pages.auth.FindPwPage.Change.PwChangeForm.required"),
						pattern: {
							value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/,
							message: t("pages.auth.FindPwPage.Change.PwChangeForm.useSpecial"),
						},
					}}
				/>
				<Input
					placeholder={t("pages.auth.FindPwPage.Change.PwChangeForm.newPwCheck")}
					name="rePw"
					type="password"
					autoComplete="new-password"
					validation={{
						required: t("pages.auth.FindPwPage.Change.PwChangeForm.required"),
						validate: t("pages.auth.FindPwPage.Change.PwChangeForm.dontMatch"),
					}}
				/>
			</Form>
			<div className="btn-wrap">
				<button className="btn__solid" color="gray">
					{t("pages.auth.FindPwPage.Change.PwChangeForm.prev")}
				</button>
				<button
					onClick={pwChangeForm.handleSubmit(submit)}
					className="btn__solid"
					color="primary"
				>
					{t("pages.auth.FindPwPage.Change.PwChangeForm.next")}
				</button>
			</div>
		</>
	);
};

export default PwChangeForm;
